import Plyr from 'plyr'

export default () => {
    return {
        mounted() {
            const player = new Plyr(this.$refs.plyr, {
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
            })
        },
    }
}
